import axios from "../axios";

const getBenchName = async function (accessToken,uuid, data) {
    try {
        const response = await axios.post('/bank-account/getBenchName',data, {
            headers: {
                'Authorization': accessToken
            },
            params: {
                uuid
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getBenchName;
